<template>
  <v-app id="inspire">
    <v-layout class="timeline" row>
      <v-flex xs12 sm6 offset-sm3 class="container-timeline">
          <v-list three-line> <template v-for="(item,itemIndex) in timelineData">

              <v-subheader :key="itemIndex" v-if="itemIndex > 0 && timelineData[itemIndex].timeSeries[0].State" v-bind:class="getTextColorClass(timelineData[itemIndex].timeSeries[0].State.value)">
                  <div class="centered-date">{{ item.header }}</div> 
                <v-divider class="vertical-line-date" vertical v-bind:class="getTextColorClass(timelineData[itemIndex].timeSeries[0].State.value)"></v-divider>    
              </v-subheader>

              <v-subheader :key="itemIndex" v-else-if="itemIndex === 0" class="first-event">
                  <div class="centered-date">{{ item.header }}</div>
                <v-divider class="vertical-line-date first-event" vertical></v-divider>    
              </v-subheader>

              <v-subheader :key="itemIndex" v-else v-bind:class="getTextColorClass(timelineData[itemIndex].timeSeries[0].state)">
                  <div class="centered-date">{{ item.header }}</div> 
                <v-divider class="vertical-line-date" vertical v-bind:class="getTextColorClass(timelineData[itemIndex].timeSeries[0].state)"></v-divider>    
              </v-subheader>

              <v-list-tile :key="index + Math.random()" v-for="(record, index) in item.timeSeries">

                <v-list-tile-content v-if="record.State" class="icon-content">
                  <i class="material-icons icon" v-bind:class="getIconColorClass(record.State.value)">trip_origin</i>
                  <v-divider class="vertical-line" vertical v-bind:class="getLineColorClass(timelineData,itemIndex,index,item,record)"></v-divider>
                </v-list-tile-content>

                <v-list-tile-content v-else class="icon-content">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" d="M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"/>
                    <path fill="#0099E1" d="M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"/>
                  </svg>
                  <v-divider class="vertical-line" vertical v-bind:class="getLineColorClass(timelineData,itemIndex,index,item,record)"></v-divider>
                </v-list-tile-content>

                <v-list-tile-content class="text-content">
                  <v-list-tile-title v-html="getTime(record.dateTime)"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-content v-if="record.State" class="text-content">
                  <v-list-tile-title v-html="record.State.label" class="text-xs-right"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-content v-else class="text-content">
                  <v-list-tile-title v-html="record.note" class="text-xs-right"></v-list-tile-title>
                </v-list-tile-content>

              </v-list-tile>
          </template> </v-list>
          <div v-if="!timelineData.length" class="without-event"> Sin Eventos </div>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { DEVICE_TIMELINE_QUERY } from '../../../constants/graphql';
  import { STATES } from '../../../constants/constants';
  import _orderBy from 'lodash/orderBy';

  export default {
    props: ['id', 'device'],
    data () {
      return {
        timelineData: [],
        allEvents: []
      };
    },
    apollo: {
      allEvents: {
        query: DEVICE_TIMELINE_QUERY,
        variables () {
          return {
            id: parseInt(this.id)
          };
        },
        result (res) {
          let data = res.data.allEvents;
          this.allEvents = data;
          data = _orderBy(data, ['dateTime'], ['desc']);

          let auxMap = this.groupByDate(data);

          this.setTimelineFormat(auxMap);
          this.updateIrrigationOrdersState();
        }
      }
    },
    watch: {
      device () {
        this.$apollo.queries.allEvents.refetch();
      }
    },
    methods: {
      groupByDate (events) {
        let auxMap = {};
        events.forEach((event) => {
          let date = new Date(event.dateTime).toLocaleDateString('es-CA');

          if (!auxMap[date]) {
            auxMap[date] = [];
          }

          auxMap[date].push(event);
        });
        return auxMap;
      },
      setTimelineFormat (map) {
        this.timelineData = [];
        Object.keys(map).forEach((date) => {
          this.timelineData.push({
            'header': date,
            'timeSeries': map[date]
          });
        });
      },
      updateIrrigationOrdersState () {
        let lastState;
        let i;
        let j;
        for (i = this.timelineData.length - 1; i >= 0; i--) {
          const timeSeries = this.timelineData[i].timeSeries;
          for (j = timeSeries.length - 1; j >= 0; j--) {
            if (timeSeries[j].note) {
              this.timelineData[i].timeSeries[j].state = lastState;
            } else {
              lastState = timeSeries[j].State.value;
            }
          }
        }
      },
      getTextColorClass (state) {
        switch (state) {
          case STATES.IRRIGATING:
            return 'state-irrigating';
          case STATES.MOVING:
            return 'state-moving';
          case STATES.OFF:
            return 'state-off';
          case STATES.FAILURE:
            return 'state-failure';
        }
      },
      getIconColorClass (state) {
        switch (state) {
          case STATES.IRRIGATING:
            return 'color-irrigating';
          case STATES.MOVING:
            return 'color-moving';
          case STATES.OFF:
            return 'color-off';
          case STATES.FAILURE:
            return 'color-failure';
        };
      },
      getLineColorClassName (state) {
        switch (state) {
          case STATES.IRRIGATING:
            return 'irrigating-line';
          case STATES.MOVING:
            return 'moving-line';
          case STATES.OFF:
            return 'off-line';
          case STATES.FAILURE:
            return 'failure-line';
        };
      },
      getLineColorClass (timelineData, itemIndex, index, item, record) {
        if (timelineData.length === (itemIndex + 1) && item.timeSeries.length === (index + 1)) {
          return 'transparent-line';
        } else if (item.timeSeries.length === (index + 1)) {
          if (timelineData[(itemIndex + 1) % timelineData.length].timeSeries[0].State) {
            return this.getLineColorClassName(timelineData[(itemIndex + 1) % timelineData.length].timeSeries[0].State.value);
          } else {
            return this.getLineColorClassName(timelineData[(itemIndex + 1) % timelineData.length].timeSeries[0].state);
          }
        } else if (record.state !== 2) {
          if (item.timeSeries[(index + 1) % item.timeSeries.length].State) {
            return this.getLineColorClassName(item.timeSeries[(index + 1) % item.timeSeries.length].State.value);
          } else {
            return this.getLineColorClassName(item.timeSeries[(index + 1) % item.timeSeries.length].state);
          }
        } else {
          return 'transparent-line';
        }
      },
      getTime (timestamp) {
        let date = new Date(timestamp);
        let hour = date.getHours().toString().padStart(2, '0');
        let minute = date.getMinutes().toString().padStart(2, '0');
        return `${hour}:${minute}`;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// Timeline.vue?cf91e4c4